import { css } from 'styled-components'

import 'focus-visible'

const focusVisible = css`
  &:focus-visible {
    outline: revert;
  }

  &.focus-visible {
    outline: revert;
  }

  &:focus:not(:focus-visible) {
    outline: 0;
  }

  &:focus:not(.focus-visible) {
    outline: 0;
  }
`

export default focusVisible
